<template>
  <div class="page-container">
    <van-nav-bar left-arrow fixed title="我的优惠券" @click-left="goableBack()" :z-index="10"></van-nav-bar>
    <div class="page">
      <van-tabs v-model="tab.active" swipeable animated sticky :offset-top="45">
        <van-tab :title="'未使用(' + recordNum.unUsedNum + ')'" name="canuse" class="canuse">
          <van-list v-model="canuse.loading" :finished="canuse.finished" finished-text="--- 我是有底线的 ---" class="list px-10 pb-10" @load="loadData">
            <div class="mt-15 px-15 py-10 item" v-for="(n, i) of canuse.data" :key="`canuse-${i}`" @click="onCellItem(n)">
              <div class="pb-10 item-content">
                <div class="left">
                  <div class="ta-c color-cyan">
                    <span class="amountStyle mr-5">{{
                      parseFloat(n.amount)
                    }}</span>
                    <span v-if="n.type == 2 || n.type == 3 || n.type == 4 || n.type == 10">元</span>
                    <span v-else>%</span>
                  </div>
                </div>
                <div class="right">
                  <div class="fs-12 color-gray-dark readpackName">
                    {{ n.name }}
                  </div>
                  <div class="fs-12 color-gray-dark limitAmount">
                    <span v-if="n.condEndAmt">满{{ parseInt(n.condStartAmt) }}元至{{ parseInt(n.condEndAmt) }}元可用</span>
                    <span v-else>满{{ parseInt(n.condStartAmt) }}元可用</span>
                  </div>
                  <div v-if="n.productName && n.productName.length > 0" class="fs-12 color-gray-dark">
                    适用于 {{ n.productName }} 产品<span class="ml-5 fs-14 color-gray-dark">
                      {{ n.useCond }}
                    </span>
                  </div>
                  <div class="fs-12 color-gray-dark">
                    有效期: {{ dateFormat(n.takeEffectTime, "YYYY.MM.DD") }} -
                    {{ dateFormat(n.expiryTime, "YYYY.MM.DD") }}
                  </div>
                  <div class="fs-12 color-gray-dark">
                    <span class="if_any_superposition" v-if="n.ifSuperposition == 2">
                      任意叠加
                    </span>
                    <span class="if_superposition" v-else-if="n.ifSuperposition == 1">
                      可叠加
                    </span>
                    <span class="if_no_superposition" v-else> 不可叠加 </span>
                    <template v-if="n.label && n.label > 0">
                      <div class="label-bg">
                        <span class="if_label">{{ n.lableString }}</span>
                      </div>
                    </template>
                  </div>
                </div>
              </div>
              <div class="pt-10 item-footer ta-c">
                <span class="color-cyan fs-12" @click.stop="onCommitUse(n)">立即使用</span>
              </div>
              <div :class="
                  n.type == 1
                    ? 'tagStyle rate-coupon-tag'
                    : n.type == 3
                    ? 'tagStyle decrecash-coupon-tag'
                    : n.type == 4
                    ? 'tagStyle experience-tag'
                    : n.type == 10
                    ? 'tagStyle cash-back-coupon-tag'
                    : 'tagStyle cash-coupon-tag'
                ">
                <span v-if="n.type == 1" class="fs-12 tagTitle"> 加息券 </span>
                <span v-else-if="n.type == 3" class="fs-12 tagTitle">
                  满减券
                </span>
                <span v-else-if="n.type == 4" class="fs-12 tagTitle">
                  体验金券
                </span>
                <span v-else-if="n.type == 10" class="fs-12 tagTitle">
                  返现券
                </span>
                <span v-else class="fs-12 tagTitle"> 代金券 </span>
              </div>
            </div>
          </van-list>
        </van-tab>
        <van-tab :title="'已使用(' + recordNum.usedNum + ')'" name="used" class="used">
          <van-list v-model="used.loading" :finished="used.finished" finished-text="--- 我是有底线的 ---" class="list px-10 pb-10" @load="loadData">
            <div class="mt-20 px-15 py-10 item" v-for="(n, i) of used.data" :key="`used-${i}`">
              <div class="pb-10 item-content">
                <div class="left">
                  <div class="ta-c color-cyan">
                    <span class="amountStyle mr-5">
                      {{ parseFloat(n.amount) }}
                    </span>
                    <span v-if="n.type == 2 || n.type == 3 || n.type == 4 || n.type == 10">元</span>
                    <span v-else>%</span>
                  </div>
                </div>
                <div class="right">
                  <div class="fs-12 color-gray-dark readpackName">
                    {{ n.name }}
                  </div>
                  <div class="fs-12 color-gray-dark limitAmount">
                    <span v-if="n.condEndAmt">满{{ parseInt(n.condStartAmt) }}元至{{ parseInt(n.condEndAmt) }}元可用</span>
                    <span v-else>满{{ parseInt(n.condStartAmt) }}元可用</span>
                  </div>
                  <div v-if="n.productName && n.productName.length > 0" class="fs-12 color-gray-dark">
                    适用于 {{ n.productName }} 产品<span class="ml-5 fs-14 color-gray-dark">{{ n.useCond }}</span>
                  </div>
                  <div class="fs-12 color-gray-dark">
                    有效期: {{ dateFormat(n.takeEffectTime, "YYYY.MM.DD") }} -
                    {{ dateFormat(n.expiryTime, "YYYY.MM.DD") }}
                  </div>
                  <div class="fs-12 color-gray-dark">
                    <span class="if_any_superposition" v-if="n.ifSuperposition == 2">
                      任意叠加
                    </span>
                    <span class="if_superposition" v-else-if="n.ifSuperposition == 1">
                      可叠加
                    </span>
                    <span class="if_no_superposition" v-else> 不可叠加 </span>
                    <template v-if="n.label && n.label > 0">
                      <div class="label-bg">
                        <span class="if_label">{{ n.lableString }}</span>
                      </div>
                    </template>
                  </div>
                </div>
              </div>
              <div class="pt-10 item-footer ta-c">
                <span class="color-cyan fs-12">已使用</span>
              </div>
              <div :class="
                  n.type == 1
                    ? 'tagStyle rate-coupon-tag'
                    : n.type == 3
                    ? 'tagStyle decrecash-coupon-tag'
                    : n.type == 4
                    ? 'tagStyle experience-tag'
                    : n.type == 10
                    ? 'tagStyle cash-back-coupon-tag'
                    : 'tagStyle cash-coupon-tag'
                ">
                <span v-if="n.type == 1" class="fs-12 color-gray-dark tagTitle">
                  加息券
                </span>
                <span v-else-if="n.type == 3" class="fs-12 tagTitle">
                  满减券
                </span>
                <span v-else-if="n.type == 4" class="fs-12 tagTitle">
                  体验金券
                </span>
                <span v-else-if="n.type == 10" class="fs-12 tagTitle">
                  返现券
                </span>
                <span v-else class="fs-12 color-gray-dark tagTitle">
                  代金券
                </span>
              </div>
            </div>
          </van-list>
        </van-tab>
        <van-tab :title="'已过期(' + recordNum.expiredNum + ')'" name="expired" class="expired">
          <van-list v-model="expired.loading" :finished="expired.finished" finished-text="--- 我是有底线的 ---" class="list px-10 pb-10" @load="loadData">
            <div class="mt-20 px-15 py-10 item" v-for="(n, i) of expired.data" :key="`expired-${i}`">
              <div class="pb-10 item-content">
                <div class="left">
                  <div class="ta-c color-cyan">
                    <span class="amountStyle mr-5">
                      {{ parseFloat(n.amount) }}
                    </span>
                    <span v-if="n.type == 2 || n.type == 3 || n.type == 4 || n.type == 10">元</span>
                    <span v-else>%</span>
                  </div>
                </div>
                <div class="right">
                  <div class="fs-12 color-cyan readpackName">
                    {{ n.name }}
                  </div>
                  <div class="fs-12 color-cyan limitAmount">
                    <span v-if="n.condEndAmt">满{{ parseInt(n.condStartAmt) }}元至{{ parseInt(n.condEndAmt) }}元可用</span>
                    <span v-else>满{{ parseInt(n.condStartAmt) }}元可用</span>
                  </div>
                  <div v-if="n.productName && n.productName.length > 0" class="fs-12 color-gray-dark">
                    适用于 {{ n.productName }} 产品<span class="ml-5 fs-14 color-gray-dark">{{ n.useCond }}</span>
                  </div>
                  <div class="fs-14 color-gray-dark">
                    有效期: {{ dateFormat(n.takeEffectTime, "YYYY.MM.DD") }} -
                    {{ dateFormat(n.expiryTime, "YYYY.MM.DD") }}
                  </div>
                  <div class="fs-12 color-gray-dark">
                    <span class="if_any_superposition" v-if="n.ifSuperposition == 2">
                      任意叠加
                    </span>
                    <span class="if_superposition" v-else-if="n.ifSuperposition == 1">
                      可叠加
                    </span>
                    <span class="if_no_superposition" v-else> 不可叠加 </span>
                    <template v-if="n.label && n.label > 0">
                      <div class="label-bg">
                        <span class="if_label">{{ n.lableString }}</span>
                      </div>
                    </template>
                  </div>
                </div>
              </div>
              <div class="pt-10 item-footer ta-c">
                <span class="color-cyan fs-16">已过期</span>
              </div>
              <div :class="
                  n.type == 1
                    ? 'tagStyle rate-coupon-tag'
                    : n.type == 3
                    ? 'tagStyle decrecash-coupon-tag'
                    : n.type == 4
                    ? 'tagStyle experience-tag'
                    : n.type == 10
                    ? 'tagStyle cash-back-coupon-tag'
                    : 'tagStyle cash-coupon-tag'
                ">
                <span v-if="n.type == 1" class="fs-12 color-gray-dark tagTitle">
                  加息券
                </span>
                <span v-else-if="n.type == 3" class="fs-12 tagTitle">
                  满减券
                </span>
                <span v-else-if="n.type == 4" class="fs-12 tagTitle">
                  体验金券
                </span>
                <span v-else-if="n.type == 10" class="fs-12 tagTitle">
                  返现券
                </span>
                <span v-else class="fs-12 color-gray-dark tagTitle">
                  代金券
                </span>
              </div>
            </div>
          </van-list>
        </van-tab>
      </van-tabs>
    </div>
  </div>
</template>

<script>
import * as PayApi from "@/api/pay"
import { mapGetters } from "vuex"
import { Icon, Button, Tab, Tabs, Loading, List } from "vant"
import { preExperienceProduct } from "../../api/product"
import session from "../../utils/session"
export default {
  name: "index",
  data: () => ({
    canuse: {
      fields: {
        status: 0 //'canuse'
      },
      data: [],
      loading: false,
      finished: false
    },
    used: {
      fields: {
        status: 1 //'used'
      },
      data: [],
      loading: false,
      finished: false
    },
    expired: {
      fields: {
        status: 2 //'expired'
      },
      data: [],
      loading: false,
      finished: false
    },
    tab: {
      active: 0 //"canuse",
    },
    recordNum: {
      unUsedNum: 0, // 未使用
      expiredNum: 0, // 已过期
      usedNum: 0 // 已使用
    }
  }),

  methods: {
    loadData() {
      let tag = this[this.tab.active]
      tag.loading = true
      let form = {
        status: tag.fields.status
      }
      PayApi.getRedBagList(form)
        .then((data) => {
          tag.data = tag.data.concat(data)
          tag.loading = false
          tag.finished = true
        })
        .catch((e) => {
          console.info(e)
        })
    },
    getRedPacketRecordNum() {
      PayApi.getRedPacketRecordNum()
        .then((data) => {
          this.recordNum = data
        })
        .catch((e) => {
          this.$toast(e.msg || e.message)
        })
    },
    onCellItem(item) {
      if (item.type == 4) {
        session.setJson("perienceKey", JSON.stringify(item))
        this.$router.push({ name: "experience_rule" })
      } else {
        this.$router.push({ name: "home" })
      }
    },
    onCommitUse(item) {
      if (item.type == 4) {
        this._showLoading()
        preExperienceProduct()
          .then((data) => {
            this._dismissLoading()
            this.$router.push({
              path: "/detail",
              query: { productId: data }
            })
          })
          .catch((e) => {
            this._dismissLoading()
            this.$toast(e.msg || e.message)
          })
      } else {
        this.$router.push({ name: "home" })
      }
    }
  },
  mounted() {
    this.getRedPacketRecordNum()
  },
  computed: {
    ...mapGetters(["userInfo"])
  },
  components: {
    [Icon.name]: Icon,
    [Button.name]: Button,
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
    [Loading.name]: Loading,
    [List.name]: List
  }
}
</script>

<style lang="less" scoped>
.list {
  .item {
    display: block;
    position: relative;
    background: #fff;
    border: 1px solid #fff;
    border-radius: 5px;
    box-shadow: 0 3px 3px #bdbdbd;
    border-top: 5px solid rgb(252, 101, 36);

    .rate-coupon-tag {
      background-color: #ff9900;
    }

    .cash-coupon-tag {
      background-color: rgb(252, 101, 36);
    }
    .decrecash-coupon-tag {
      background-color: rgb(28, 184, 77);
    }
    .experience-tag {
      background-color: rgb(253, 181, 10);
    }
    .cash-back-coupon-tag {
      background-color: rgb(218, 96, 44);
    }
    .if_any_superposition {
      font-size: 10px;
      color: white;
      padding: 3px 10px;
      border-radius: 20px;
      background-color: #ff9900;
    }
    .if_superposition {
      font-size: 10px;
      color: white;
      padding: 3px 10px;
      border-radius: 20px;
      background-color: rgb(252, 101, 36);
    }

    .if_no_superposition {
      font-size: 10px;
      padding: 3px 10px;
      border-radius: 20px;
      background-color: #e7eaed;
    }
    .label-bg {
      margin-top: 5px;
      .if_label {
        font-size: 10px;
        padding: 3px 10px;
        border-radius: 20px;
        color: white;
        background-color: rgb(228, 152, 20);
      }
    }
    .item-content {
      border-bottom: 1px dashed @gray-light;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      .left {
        text-align: center;
        width: 35%;
        display: flex;
        justify-content: center;
        align-items: center;
        .amountStyle {
          font-size: 30px;
          font-weight: 800;
        }
      }
      .right {
        .readpackName {
          margin-top: 10px;
        }
        .name {
          line-height: 30px;
        }
        flex: 1;
      }
    }

    .tagStyle {
      position: absolute;
      right: -1px;
      top: -5px;
      overflow: hidden;
      border-bottom-left-radius: 6px;

      .tagTitle {
        font-size: 10px;
        margin-right: 10px;
        margin-left: 10px;
        color: #fff;
      }
    }

    .item-footer {
      overflow: hidden;
      position: relative;
      .text {
        margin-top: 5px;
        font-size: 12px;
        color: @gray-dark;
      }
      .expand {
        height: 0;
        transition: all ease 0.5s;
      }
      button {
        position: absolute;
        top: 10px;
        right: 5px;
      }
    }
  }
}
.used .item {
  opacity: 0.5;
}
.expired .item {
  filter: grayscale(1);
  opacity: 0.5;
}
.van-tabs {
  ::v-deep .van-sticky--fixed {
    top: 45px;
  }
}
</style>